<template>
    <v-container fluid px-3 pt-3>
        <certificate-instructions v-show="!this.$route.query.code && !this.$route.query.error" />
    </v-container>
</template>

<script>
//import HelloWorld from '../components/HelloWorld'

import CertificateInstructions from '../components/core/CertificateInstructions.vue'

export default {
    name: 'Home',
    components: {
        //HelloWorld
        CertificateInstructions
    },
    data () {
        return {
            error: this.$route.query.error
        }
    },
    mounted () {
        if (this.$route.query.error) {
            this.$router.push('/login-error?error=' + this.$route.query.error + '&error_description=' + this.$route.query.error_description)
        }
    }
}
</script>
